import * as React from 'react';
import theme from '../theme/theme';
import { Avatar, Grid, Typography, useMediaQuery } from '@mui/material';
import { trunc } from '../utils';

const DisplayTeam = ({team}) => {

  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Grid container direction="column" alignItems="center">
      <Grid item>
        <Avatar src={team.flag} sx={{
          border: '2px solid #ffffff',
          width: isMdUp ? '100px' : isSmUp ? '70px' : '40px',
          height: isMdUp ? '100px' : isSmUp ? '70px' : '40px'}} />
      </Grid>
      <Grid item>
        <Typography variant={isMdUp ? "h4" : isSmUp ? "h5" : "subtitle2"} 
        sx={{fontWeight: '900', mt: isMdUp ? 3 : isSmUp ? 2 : 1}}>
          {trunc(team.name, isSmUp ? 20 : 10)}
        </Typography>
      </Grid>
    </Grid>
  );
};
export default DisplayTeam;